"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _PromotionSelectors = require("../../../selectors/PromotionSelectors");

var _SuiteCovidPromoBanner = _interopRequireDefault(require("../../growth-suite-page/SuiteCovidPromoBanner"));

var _Editions = require("self-service-api/constants/Editions");

var _CovidSelectors = require("../../../selectors/CovidSelectors");

var _CurrencySelectors = require("../../../selectors/CurrencySelectors");

// As of 1/21/2020 this URL has not been localized into other languages
// so this only the English URL is linked from here.
var GROWTH_SUITE_TERMS_URL = 'https://legal.hubspot.com/growth-suite-bundle-pricing';

var GrowthSuiteAlert = function GrowthSuiteAlert(_ref) {
  var isGrowthSuiteSelected = _ref.isGrowthSuiteSelected,
      isHSFXEligible = _ref.isHSFXEligible,
      isLatamEsEligible = _ref.isLatamEsEligible,
      isCovidGrowthSuitePromoEligible = _ref.isCovidGrowthSuitePromoEligible,
      currencyCode = _ref.currencyCode,
      _ref$covidPromoProps = _ref.covidPromoProps,
      activeEdition = _ref$covidPromoProps.activeEdition,
      fromPrice = _ref$covidPromoProps.fromPrice,
      toPrice = _ref$covidPromoProps.toPrice;

  if (isCovidGrowthSuitePromoEligible && isGrowthSuiteSelected && activeEdition === _Editions.STARTER) {
    return _react.default.createElement(_UIAlert.default, {
      type: "info",
      className: "m-bottom-8"
    }, _react.default.createElement(_SuiteCovidPromoBanner.default, {
      toPrice: toPrice,
      fromPrice: fromPrice,
      currencyCode: currencyCode,
      xPadding: 0,
      yPadding: 0
    }));
  }

  if (isHSFXEligible || isLatamEsEligible) {
    // Don't return text about 25% discount if discount is higher
    return null;
  }

  return _react.default.createElement(_UIAlert.default, {
    type: "info",
    className: "m-bottom-8"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: isGrowthSuiteSelected ? 'bundles.discountText.saving25_jsx' : 'bundles.discountText.save25_jsx',
    elements: {
      UILink: _UILink.default,
      Bold: _styledComponents.default.b.withConfig({
        displayName: "GrowthSuiteAlert__Bold",
        componentId: "sc-1qz6fw0-0"
      })(["font-size:16px;"])
    },
    options: {
      link: GROWTH_SUITE_TERMS_URL,
      onClick: function onClick() {
        (0, _getUsageTracker.default)().track('externalLinkClick', {
          name: 'growth-suite-terms',
          url: GROWTH_SUITE_TERMS_URL
        });
      }
    }
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isHSFXEligible: (0, _PromotionSelectors.isHSFXEligibleSelector)(state),
    isLatamEsEligible: (0, _PromotionSelectors.isLatamEsEligibleSelector)(state),
    isCovidGrowthSuitePromoEligible: (0, _CovidSelectors.isCovidGrowthSuitePromoEligibleSelector)(state),
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteAlert);

exports.default = _default;
module.exports = exports.default;